import { useIntl } from 'react-intl';

import {
  DerivedEventTypeLegacy,
  type FilterLegacy,
  FilterTypeLegacy,
} from '@verantos-dev/types-cohorts';

import { type CohortBuilderEditModalActionButtonProps } from '../../../../../components/CohortBuilderEditModal/CohortBuilderEditModalActions/CohortBuilderEditModalActionButton';
import { getAvailableEventTypes } from '../../../../../utils/getAvailableEventTypes';

export const useDerivedEventCohortBuilderEditModalActions = ({
  type,
  uniquenessFilters,
  onAddTemporalConstraintClick,
  onAddCohortBuilderEventClick,
  onAddUniquenessFilterClick,
}: {
  type: DerivedEventTypeLegacy | undefined;
  uniquenessFilters: FilterLegacy[];
  onAddTemporalConstraintClick: () => void;
  onAddCohortBuilderEventClick: () => void;
  onAddUniquenessFilterClick: () => void;
}): CohortBuilderEditModalActionButtonProps[] => {
  const intl = useIntl();

  const availableTypes = getAvailableEventTypes(type);

  const actions: CohortBuilderEditModalActionButtonProps[] = [];

  if (availableTypes.includes(FilterTypeLegacy.EVENT)) {
    actions.push({
      id: 'add-cohort-builder-event',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.derivedEventsEditModal.addCohortBuilderEventButtonLabel',
      }),
      onClick: onAddCohortBuilderEventClick,
      disabled: !type,
    });
  }

  if (availableTypes.includes(FilterTypeLegacy.UNIQUENESS)) {
    actions.push({
      id: 'add-uniqueness-filter',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.derivedEventsEditModal.addUniquenessFilterButtonLabel',
      }),
      title: uniquenessFilters.length
        ? intl.formatMessage({
            id: 'projects.cohortBuilderPage.derivedEventsEditModal.uniquenessFilterRestrictionTitle',
          })
        : undefined,
      onClick: onAddUniquenessFilterClick,
      disabled: !type,
    });
  }

  if (availableTypes.includes(FilterTypeLegacy.TEMPORAL)) {
    actions.push({
      id: 'add-temporal-constraint',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.derivedEventsEditModal.addTemporalConstraintButtonLabel',
      }),
      onClick: onAddTemporalConstraintClick,
      disabled: !type,
    });
  }

  return actions;
};
